// The messaging lists' pages (spec 17 §4.1, §4.2 and §4.3). The cursor
// stack and the loaded-pages window are the shared ones in lib/cursor-pages
// (D-560); what stays here is the range line in the messaging words.

import type { TFunction } from "i18next";

export * from "../../../../lib/cursor-pages";

/** "Showing 26–50" in the reader's digits. */
export function pageRangeLabel(
  t: TFunction,
  locale: string,
  view: { readonly from: number; readonly to: number },
): string {
  const n = new Intl.NumberFormat(locale);
  return t("messaging.common.pageRange", { from: n.format(view.from), to: n.format(view.to) });
}
